import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=0a83f4de&scoped=true&"
import script from "./AllUsers.vue?vue&type=script&lang=js&"
export * from "./AllUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83f4de",
  null
  
)

export default component.exports